import { BadgeBlack } from "./badge_black";
import { BikeScooter } from "./bike_scooter";
import { BookmarkAdded } from "./bookmark_added";
import { Bookmark } from "./bookmark";

const iconsList = [
  { label: "BadgeBlack", code: <BadgeBlack /> },
  { label: "BikeScooter", code: <BikeScooter /> },
  { label: "BookmarkAdded", code: <BookmarkAdded /> },
  { label: "Bookmark", code: <Bookmark /> },
];

export {
  iconsList,
  BadgeBlack,
  BikeScooter,
  BookmarkAdded,
  Bookmark,
};
